import shareApiImpl from '../share-api';
import type { ShareApi } from './contracts';

export type { ShareApi } from './contracts';
export const shareApi: ShareApi = shareApiImpl;
